import { Translatable } from "@icc/shared/helpers";

export class SteelSideBracket {
    id: number;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do wydruków */
    printCode: string;
    /** Skrócony opis */
    shortDescription: string;
    /** Zdjęcie */
    img: string;
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Przypisane profile */
    profilesIds: number[];
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}
